import { useSelector } from 'react-redux';
import { Theme } from '@raydiant/api-client-js';
import { selectIsContentSharingEnabled } from '../../selectors/user';
import ThemeShare from './ThemeShare/ThemeShare';
import ThemeShareV2 from './ThemeShare/ThemeShareV2';

export interface ThemeSharingModalProps {
  theme?: Theme;
  onClose: () => void;
}

const ThemeSharingModal = ({ theme, onClose }: ThemeSharingModalProps) => {
  const isContentSharingEnabled = useSelector(selectIsContentSharingEnabled);

  return (
    <>
      {theme && isContentSharingEnabled ? (
        <ThemeShareV2 theme={theme} onClose={onClose} />
      ) : (
        <ThemeShare theme={theme} onClose={onClose} />
      )}
    </>
  );
};

export default ThemeSharingModal;
